import { BreadcrumbComponent } from "@/components/breadcrumb/Breadcrumb";
import { SectionHeader } from "@/components/common/section-components/SectionHeader";
import { AppRoutes } from "@/constants/routes";
import { Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { PersonaDetalle } from "../schema/person.schema";
import { AssociateAccountCard } from "@/components/common/section-components/AssociateAccountCard";
import { useRoles } from "@/hooks/useRoles";
import {
  associateAccountHandler,
  fetchPersonDetailHandler,
} from "../schema/handler-functions";

export const PersonAssociateAccountPage = () => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const [loadingPersonData, setLoadingPersonData] = useState<boolean>(false);
  const navigate = useNavigate();

  const { id } = useParams();

  const [loadingPersons, setLoadingPersons] = useState<boolean>(false);
  const [loadingAssociateAccount, setLoadingAssociateAccount] =
    useState<boolean>(false);

  const [personData, setPersonData] = useState<PersonaDetalle | null>();

  useEffect(() => {
    setIsActive(true);
  }, []);

  const fetchPersonDetail = async (id: number) => {
    await fetchPersonDetailHandler({
      id,
      setLoadingPersonData,
      setPersonData,
      navigate,
      fetchPermissions,
      routeOnPermissionError: AppRoutes.PERSON_DETAIL.replace(":id", String(id)),
    });
  };

  useEffect(() => {
    if (isActive && id) fetchPersonDetail(Number(id));
  }, [isActive, id]);

  const methods = useForm();

  const { fetchPermissions } = useRoles();

  const handleCancel = () => {
    navigate(AppRoutes.PERSON_DETAIL.replace(":id", String(id)));
  };

  const handleAssociateAccount = methods.handleSubmit(
    async (event: FieldValues) => {
      await associateAccountHandler({
        event,
        personId: Number(personData?.id),
        setLoadingAssociateAccount,
        navigate,
        fetchPermissions,
      });
    },
  );

  return (
    <Flex flexDir="column" paddingTop="20px" gap="12px">
      <SectionHeader
        title="Asociar cuenta"
        addButtonLabel="Asociar"
        cancelButtonLabel="Cancelar"
        loading={loadingPersonData || loadingAssociateAccount}
        breadcrumbComponent={
          <BreadcrumbComponent
            options={[
              {
                label: "Maestro de personas",
                href: AppRoutes.PERSONS,
              },
              {
                label: personData
                  ? personData?.nombre + " " + personData?.apellido
                  : "Cargando...",
                href: AppRoutes.PERSON_DETAIL.replace(
                  ":id",
                  String(personData?.id),
                ),
              },
              {
                label: "Asociar cuenta",
                href: "#",
                strong: true,
              },
            ]}
          />
        }
        handleCancel={handleCancel}
        handleAdd={handleAssociateAccount}
      />

      {!loadingPersonData && (
        <FormProvider {...methods}>
          <AssociateAccountCard
            loadingPersons={loadingPersons}
            setLoadingPersons={setLoadingPersons}
          />
        </FormProvider>
      )}
    </Flex>
  );
};
